<template>
  <div class="tbp">
    <div class="invoice">
      <div class="title">
        <div>{{detail.invoiceTypeName}}</div>
        <div class="invoicestatus">{{detail.applyStatusName}}</div>
      </div>
      <div class="row">
        <span>公司名称</span>
        <span>{{detail.companyName}}</span>
      </div>
      <div class="row">
        <span>税号</span>
        <span>{{detail.taxId ? detail.taxId : ''}}</span>
      </div>
       <div class="row">
        <span>接收邮箱</span>
        <span>{{detail.receiveEmail ? detail.receiveEmail : ''}}</span>
      </div>
      <div class="row">
        <span>发票金额</span>
        <span>{{detail.totalAmount}}</span>
      </div>
      <div class="row">
        <span>开具发票时间</span>
        <span>{{detail.applyTime}}</span>
      </div>
    </div>
    <div class="detail">
      <div class="order-number">1张发票，含<span>{{orderList.length}}</span>个订单</div>
      <div class="order-item" v-for="(item,index) in orderList" :key="item.orderId" :class="index === orderList.length - 1 ? 'no-border':'border-devider'">
        <div class="info">
          <div class="row">
            <span>订单编号</span>
            <span>{{item.orderSn}}</span>
          </div>
          <div class="row">
            <span>创建时间</span>
            <span>{{item.createTime}}</span>
          </div>
        </div>
        <div class="price">￥{{item.availableAmount}}</div>
      </div>
    </div>
    <div class="bottom">
      <!-- 目前后端代码暂不支持下面2个功能，待后端功能完善后在补充逻辑 -->
      <!-- <div class="repeat-send">重发发票</div> -->
      <!-- <div class="repeat-apply">申请重开</div> -->
      <div class="repeat-send-apply" @click="toChangeInvoice(detail)" v-if="detail.canReApply == 'true'">重开申请</div>
      <!-- <div class="repeat-send-apply" @click="reTrySubmit(detail)" v-if="detail.canErrorApply == 'true'">再次提交</div> -->
      <div class="repeat-send" v-if="detail.spUrl && detail.invoiceType == '2'" @click="searchInvoice(detail.spUrl,2)">查看发票</div>
      <div class="repeat-send" v-if="detail.pdfUrl && detail.invoiceType == '3'" @click="searchInvoice(detail.pdfUrl,3)">下载发票</div>
      <div :class="[detail.spUrl ? 'repeat-apply' : 'single-repeat-apply']" @click="toList">返回列表</div>
    </div>
    <selectpopupinvoice v-if="popupstate" @onselectpopup="onselectpopup" title="申请重开发票须知"/>
    <selectpopup v-if="reTryPopupstate" @onselectpopup="retryonselectpopup" title="再次提交" content="是否确定要再次提交 ？"/>
  </div>
</template>

<script>
import { invoiceDetail } from '@/service/invoice/detail.js';
import { InvoiceRetry } from '@/service/invoice/apply.js'
export default {
  name: 'invoiceDetail',
  data () {
    return {
      detail: {},
      orderList: [],
       popupstate: false,
      reTryPopupstate: false,
    }
  },
  mounted(){
    const id = this.$route.query.id
    this.getDetail(id)
  },
  methods:{
    async getDetail(id) {
      const parameter = {
          id,
      };
      const { data } = await invoiceDetail.call(this, parameter);
      this.detail = data
      this.orderList = data.detailList
    },
    searchInvoice(url,type){
      if(type == 2){
        window.location.href = url
      }else{
        // window.location.href =  process.env.VUE_APP_INVOICE_SD_URL + url
        // this.$router.push({path:'/pdf/show',query:{ url: process.env.VUE_APP_INVOICE_SD_URL + url }})
        window.open(process.env.VUE_APP_INVOICE_SD_URL + url)
      }
    },
    toList() {
      this.$router.push(`/myinvoice`);
    },
    toChangeInvoice(detail) {
      const baseInfo = {
        orderType: detail.orderType,
        orderCount: detail.detailList.length,
        totalPrice: detail.totalAmount
      }
      window.sessionStorage.setItem('baseInfo', JSON.stringify(baseInfo));
      detail.type = detail.invoiceHeader
    if(detail.reserve1 != "") {
      detail.address = JSON.parse(detail.reserve1).address
      detail.accountName = JSON.parse(detail.reserve1).accountName
      detail.phone = JSON.parse(detail.reserve1).phone
      detail.accountNo = JSON.parse(detail.reserve1).accountNo
    }


      window.sessionStorage.setItem('selectedInvoiceTitle', JSON.stringify(detail));
      this.popupstate = true
    },
    onselectpopup(state) {
      if(state === 'determine'){
        this.$router.push(`/wirteInvoiceName`);
      }
      this.$store.commit('setWindowMaskEl', null)
      this.popupstate = false;
    },
    reTrySubmit(detail) {
      const baseInfo = {
        orderType: detail.orderType,
        orderCount: detail.detailList.length,
        totalPrice: detail.totalAmount
      }
      window.sessionStorage.setItem('baseInfo', JSON.stringify(baseInfo));
      detail.type = detail.invoiceHeader
       if(detail.reserve1 != "") {
          detail.address = JSON.parse(detail.reserve1).address
          detail.accountName = JSON.parse(detail.reserve1).accountName
          detail.phone = JSON.parse(detail.reserve1).phone
          detail.accountNo = JSON.parse(detail.reserve1).accountNo
       }

      window.sessionStorage.setItem('selectedInvoiceTitle', JSON.stringify(detail));
      this.$router.push(`/alignWirteInvoice`);

      // this.reTryPopupstate = true
      // console.log(detail)
    },
    async retryonselectpopup(state) {
      if(state === 'determine'){
        
        this.$throttle(this._retryInvoice(),3000)
        
      }
      this.$store.commit('setWindowMaskEl', null)
      this.reTryPopupstate = false;
    },
    async _retryInvoice() {
      const parameter = {
          applyId: this.detail.id
        }
        const res =await InvoiceRetry.call(this, parameter);
        console.log(res)
        if(res.errorMessage == '') {
        this.$toast(`提交成功`);
        // this.invoiceRow == {}
        const id = this.$route.query.id
        this.getDetail(id);
      }
    },
  }
}
</script>

<style scoped lang='less'>
.tbp {
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  overflow-y:hidden;
}
.invoice{
  background: #FFFFFF;
  padding: .4rem;
  margin: (.533333rem / 2);
  border-radius: .266667rem;
  font-size: .373333rem;
  .title{
    display: flex;
    justify-content: space-between;
    font-size: .48rem;
    font-weight: 500;
    .invoicestatus{
      color: #3B6D9C;
    }
  }
  .row{
      margin-top: .32rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // white-space: nowrap;
      span:first-child{
        width: 6.75em;
        color: #000;
        font-size: .373333rem;
      }
      span:last-child{
        flex: 1;
        padding-left: 0.5rem;
        font-size: .373333rem;
        color: #999;
      }
    }
}
.detail{
  background: #FFFFFF;
  padding: .4rem;
  margin: (.533333rem / 2);
  border-radius: .266667rem;
  font-size: .373333rem;
  .order-number{
    font-size: .48rem;
    font-weight: 500;
    color: #333333;
    span{
      color: #3B6D9C;
    }
  }
  .order-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid rgba(151, 151, 151, .24);
    padding-bottom: .453333rem;
    .info{
      font-size: .32rem;
      color: #333;
      .row{
        margin-top: .32rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // white-space: nowrap;
        span:first-child{
          width: 6.75em;
        }
        span:last-child{
          flex: 1;
          // padding-left: 0.5rem;
        }
      }
    }
    .price{
      font-size: .48rem;
      font-weight: bold;
      color: #3B6D9C;
    }
  }
  .border-devider{
    border-bottom: 1px solid rgba(151, 151, 151, .24);
  }
}
.bottom{
  height: 1.6rem + .346667rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgb(248, 248, 248);
  display: flex;
  justify-content: space-around;
  align-items: center;
  .repeat-send-apply{
    border-radius: .6rem;
    text-align: center;
    padding: .32rem 0.6rem;
    font-size: .4rem;
    border:.013333rem solid #3B6D9C;
    color: #3B6D9C;
  }
  .repeat-send{
    border-radius: .6rem;
    text-align: center;
    padding: .32rem 0.6rem;
    font-size: .4rem;
    border:.013333rem solid #3B6D9C;
    color: #3B6D9C;
  }
  .repeat-apply{
    border-radius: .6rem;
    text-align: center;
    padding: .32rem 0.6rem;
    font-size: .4rem;
    border:.013333rem solid #3B6D9C;
    color: #3B6D9C;
  }
  .single-repeat-apply{
    border-radius: .6rem;
    text-align: center;
    padding: .32rem 0.6rem;
    font-size: .4rem;
    border:.013333rem solid #3B6D9C;
    color: #3B6D9C;
  }
}
</style>
